import React, { useEffect, useState } from "react";
import axios from "axios";
import { SealCheck, CaretUp, CaretDown } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Change = ({ value, unit = "" }) => {
  if (value === null || value === undefined) return <span className="text-[#9CA3AF] text-xs">—</span>;
  const up = value > 0;
  return (
    <span className={`inline-flex items-center gap-0.5 font-mono text-xs ${up ? "text-[#059669]" : value < 0 ? "text-[#DC2626]" : "text-[#4B5563]"}`}>
      {up ? <CaretUp size={11} weight="fill" /> : value < 0 ? <CaretDown size={11} weight="fill" /> : null}
      {up ? "+" : ""}{value.toFixed(2)}{unit}
    </span>
  );
};

export const EUDairyPrices = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/irish-markets/eu-dairy`, { timeout: 60000 })
      .then((res) => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="bg-white border border-[#E0D4C8] p-6 mb-6 animate-pulse" data-testid="eu-dairy-loading"><div className="h-5 bg-[#E5E7EB] w-1/3 mb-4"></div><div className="h-16 bg-[#F3F4F6]"></div></div>;
  }
  if (!data?.available) return null;

  return (
    <div className="bg-white border-2 border-[#0369A1] mb-6" data-testid="eu-dairy-prices">
      <div className="px-4 py-3 bg-[#0369A1] flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <SealCheck size={20} className="text-[#BAE6FD]" weight="fill" />
          <h2 className="font-serif text-lg text-white">Official EU Dairy Quotes — Ireland</h2>
          <span className="px-2 py-0.5 bg-[#BAE6FD] text-[#0C4A6E] text-[10px] font-mono uppercase tracking-wide" data-testid="eu-dairy-official-tag">Official</span>
        </div>
        {data.stale && <span className="text-[10px] font-mono text-[#BAE6FD]">last reported</span>}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 divide-y md:divide-y-0 md:divide-x divide-[#E0D4C8]">
        {data.raw_milk && (
          <div className="p-4 bg-[#F0F9FF]" data-testid="eu-dairy-raw-milk">
            <p className="text-[10px] font-mono uppercase text-[#6B6661] mb-1">Irish Milk Price</p>
            <p className="text-2xl font-mono text-[#111827]">{data.raw_milk.cent_per_litre?.toFixed(1)}<span className="text-sm">c/L</span></p>
            <Change value={data.raw_milk.change} unit="" />
            <p className="text-[10px] font-mono text-[#6B6661] mt-1">€{data.raw_milk.price_eur_100kg?.toFixed(2)}/100kg · {data.raw_milk.month}</p>
          </div>
        )}
        {(data.products || []).map((p) => (
          <div key={p.code} className="p-4" data-testid={`eu-dairy-${p.code.toLowerCase()}`}>
            <p className="text-[10px] font-mono uppercase text-[#6B6661] mb-1">{p.label}</p>
            <p className="text-2xl font-mono text-[#111827]">€{p.price_eur_100kg?.toFixed(0)}</p>
            <Change value={p.change} />
            <p className="text-[10px] font-mono text-[#6B6661] mt-1">per 100kg · w/e {p.week_ending}</p>
          </div>
        ))}
      </div>

      <div className="px-4 py-2 bg-[#F9FAFB] border-t border-[#E0D4C8]">
        <p className="text-[11px] text-[#6B6661]">
          Source: <a href={data.source_url} target="_blank" rel="noopener noreferrer" className="underline hover:text-[#0369A1]">EU Commission Agri-food Data Portal</a> — official reported prices. Raw milk monthly; product quotes weekly.
        </p>
      </div>
    </div>
  );
};

export default EUDairyPrices;
